import { ProductLabel } from "../../ui/product-label.tsx";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { q } from "../../api.ts";
import { titleOf } from "../../inbox-items.ts";
import { INBOX_LABELS as I } from "../../labels.ts";
import { reviewItems, SourceReview } from "../../source-review.tsx";
import { Callout, Pill } from "../../ui.tsx";
import { DetailPanelShell, Review, useInbox } from "./shared.tsx";

// Part of the inbox (docs/design-system.md §0.4): a product's facts that wait
// for review, decided one at a time as in the profile's "To review" tab.

export function FactReview() {
  const { factProductId } = useParams({ strict: false }) as { factProductId: string };
  const { items, done } = useInbox();
  const item = items.find((entry) => entry.key === `fact_review:${factProductId}`);
  const review = useQuery(q.sourceReview(factProductId));
  const left = review.data ? reviewItems(review.data).length : null;
  // The last decision moves on to the next item, as the other reviews do.
  const waited = useRef(false);
  useEffect(() => {
    if (left) waited.current = true;
    else if (left === 0 && waited.current) { waited.current = false; done(I.factsDone); }
  }, [left, done]);
  if (!item) return <DetailPanelShell><Callout>{I.closed}</Callout></DetailPanelShell>;
  return <Review label={I.detail} title={titleOf(item)}
    meta={<><Pill tone="amber" status>{I.reason[item.reason.code] ?? item.reason.code}</Pill><ProductLabel product={item.product} /></>}>
    <SourceReview productId={item.product.id} />
    <p><Link to="/p/$productId/profile" params={{ productId: item.product.id }} search={{ view: "review" }}>{I.openProfileReview}</Link></p>
  </Review>;
}
